import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

export {
    FindConversationShapeName,
    getFindConversationShape,
} from './utils/findConversationShapeUtil';
export { getFindItemShape } from './utils/findItemShapeUtil';
export { getFindItemTraversal } from './utils/getFindItemTraversal';
export { findItem } from './findItem';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FindMailRows" */ './lazyIndex'),
    { name: 'FindMailRows' }
);

export const lazygetConversationRowById: LazyAction<
    typeof lazyIndex.getConversationRowById,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getConversationRowById);

export { getConversationRows } from './getConversationRows';
export { getItemRows } from './getItemRows';
